module.exports = __webpack_public_path__ + "img/home-banner-btn.aa30ece9.png";